import React from "react";
import clsx from "clsx";

import DialogContent from "@material-ui/core/DialogContent";

import { EModalConfirmationTypes } from "interfaces/VetExamState";
import { checkTypeModal } from "../../helper";

import useStyles from "./styles";

interface IProps {
  type: EModalConfirmationTypes;
  horseName?: string;
}

const VetExamModalContent = (props: IProps) => {
  const { type, horseName = "Horse Name" } = props;

  const { isPauseOrCloseModal, isResetModal, isExamEditInProgressModal } =
    checkTypeModal(type);

  const classes = useStyles();

  let contentText: string = "";

  if (isPauseOrCloseModal) {
    contentText =
      "Would you like to pause this exam and continue at a later time?";
  } else if (isResetModal) {
    contentText = `Clear all fields and reset the exam form for ${horseName}?`;
  } else if (isExamEditInProgressModal) {
    contentText = `An exam edit for ${horseName} has been started and not saved, would you like to discard this exam?`;
  }

  return (
    <DialogContent className={classes.dialogContent}>
      <div
        className={clsx(classes.contentText, {
          examEditInProgress: isExamEditInProgressModal
        })}
      >
        {contentText}
      </div>
    </DialogContent>
  );
};

export default React.memo(VetExamModalContent);
